import React from 'react';

const GiftIcon: React.FC = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.7261 4.5288C5.60724 4.18854 5.54509 3.8277 5.54509 3.46105C5.54509 2.61764 5.87397 1.80499 6.46536 1.20285C7.05738 0.600058 7.86448 0.257812 8.71019 0.257812C10.6265 0.257812 11.8155 1.55882 12.4854 2.68398C13.1554 1.55882 14.3444 0.257812 16.2607 0.257812C17.1064 0.257812 17.9135 0.600058 18.5055 1.20285C19.0969 1.80499 19.4258 2.61764 19.4258 3.46105C19.4258 3.8277 19.3636 4.18854 19.2448 4.5288L21.5895 4.5288C21.8138 4.52878 22.0323 4.52875 22.2182 4.54144C22.4215 4.55531 22.6625 4.58784 22.9124 4.69135C23.4356 4.90809 23.8513 5.32382 24.0681 5.84707C24.1716 6.09697 24.2041 6.33799 24.218 6.54126C24.2307 6.72702 24.2307 6.94555 24.2306 7.16968V7.22664C24.2307 7.45076 24.2307 7.66931 24.218 7.85507C24.2041 8.05834 24.1716 8.29935 24.0681 8.54925C23.8513 9.07251 23.4356 9.48823 22.9124 9.70497C22.6625 9.80848 22.4215 9.84102 22.2182 9.85489C22.0323 9.86757 21.8138 9.86755 21.5896 9.86753H3.38133C3.15706 9.86755 2.93858 9.86757 2.7527 9.85489C2.54943 9.84102 2.30841 9.80848 2.05852 9.70497C1.53526 9.48823 1.11954 9.07251 0.902797 8.54925C0.799286 8.29935 0.766748 8.05834 0.752879 7.85507C0.740201 7.66926 0.740218 7.45078 0.740236 7.22659V7.1698C0.740218 6.94561 0.740202 6.72706 0.752879 6.54126C0.766748 6.33799 0.799286 6.09697 0.902797 5.84707C1.11954 5.32382 1.53526 4.90809 2.05852 4.69135C2.30841 4.58784 2.54943 4.55531 2.7527 4.54144C2.93853 4.52876 3.15713 4.52878 3.38134 4.52879L5.7261 4.5288ZM8.71019 2.3933C8.44339 2.3933 8.18355 2.50103 7.98892 2.69921C7.79364 2.89803 7.68058 3.17172 7.68058 3.46105C7.68058 3.75038 7.79364 4.02407 7.98892 4.22289C8.18355 4.42106 8.44339 4.52879 8.71019 4.52879H11.0272C10.9499 4.34584 10.8609 4.15632 10.7595 3.96852C10.2407 3.00812 9.57473 2.3933 8.71019 2.3933ZM13.9437 4.52879C14.021 4.34584 14.1099 4.15632 14.2114 3.96852C14.7302 3.00812 15.3961 2.3933 16.2607 2.3933C16.5275 2.3933 16.7873 2.50103 16.982 2.69921C17.1772 2.89803 17.2903 3.17172 17.2903 3.46105C17.2903 3.75038 17.1772 4.02407 16.982 4.22289C16.7873 4.42106 16.5275 4.52879 16.2607 4.52879H13.9437Z"
        fill="url(#paint0_linear_3594_5162)"
      />
      <path
        d="M2.87573 13.0708C2.87573 12.4811 3.35378 12.003 3.94348 12.003H10.5635C10.8625 12.003 11.012 12.003 11.1262 12.0612C11.2266 12.1124 11.3083 12.1941 11.3595 12.2945C11.4177 12.4087 11.4177 12.5582 11.4177 12.8572V22.894C11.4177 23.193 11.4177 23.3425 11.3595 23.4567C11.3083 23.5572 11.2266 23.6388 11.1262 23.69C11.012 23.7482 10.8625 23.7482 10.5635 23.7482H7.319C6.75626 23.7482 6.27061 23.7482 5.87073 23.7156C5.4486 23.6811 5.02874 23.6049 4.62473 23.3991C4.022 23.092 3.53197 22.6019 3.22486 21.9992C3.01901 21.5952 2.94286 21.1753 2.90837 20.7532C2.87569 20.3533 2.87571 19.8677 2.87573 19.3048L2.87573 13.0708Z"
        fill="url(#paint1_linear_3594_5162)"
      />
      <path
        d="M19.1002 23.7156C18.7002 23.7482 18.2146 23.7482 17.6517 23.7482H14.4074C14.1084 23.7482 13.9589 23.7482 13.8447 23.69C13.7442 23.6388 13.6626 23.5572 13.6114 23.4567C13.5532 23.3425 13.5532 23.193 13.5532 22.894V12.8572C13.5532 12.5582 13.5532 12.4087 13.6114 12.2945C13.6626 12.1941 13.7442 12.1124 13.8447 12.0612C13.9589 12.003 14.1084 12.003 14.4074 12.003H21.0274C21.6171 12.003 22.0951 12.4811 22.0951 13.0708V19.3049C22.0952 19.8677 22.0952 20.3533 22.0625 20.7532C22.028 21.1753 21.9519 21.5952 21.746 21.9992C21.4389 22.6019 20.9489 23.092 20.3461 23.3991C19.9421 23.6049 19.5223 23.6811 19.1002 23.7156Z"
        fill="url(#paint2_linear_3594_5162)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3594_5162"
          x1="12.4868"
          y1="24.8175"
          x2="1.29442"
          y2="9.06713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED8FF" />
          <stop offset="0.926577" stopColor="#9D4EDD" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3594_5162"
          x1="12.4868"
          y1="24.8175"
          x2="1.29442"
          y2="9.06713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED8FF" />
          <stop offset="0.926577" stopColor="#9D4EDD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3594_5162"
          x1="12.4868"
          y1="24.8175"
          x2="1.29442"
          y2="9.06713"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED8FF" />
          <stop offset="0.926577" stopColor="#9D4EDD" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GiftIcon;
